import React from "react";
import RenderHTML from "react-native-render-html";
import { StyleSheet, Text, View } from "react-native";

import SectionTitle from "./SectionTitle";

import { type EventOverview } from "@/schemas/events/EventOverview";
import { themes } from "@/Components/Styling/themeConfigs";

type Props = {
  event: EventOverview;
};

function EventDescription({ event }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      flex: 1,
    },
    description: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },
    highlightsContainer: {
      paddingHorizontal: 16,
      paddingBottom: 8,
      flexDirection: "row",
    },
    highlightCard: {
      flex: 1,
      backgroundColor: "#FFFFFF",
      borderRadius: 12,
      padding: 16,
    },
    highlightTitle: {
      fontSize: currentTheme.typography.h2.size.web,
      fontWeight: "600",
      color: "#000000",
      marginBottom: 8,
    },
    highlightDescription: {
      fontSize: currentTheme.typography.h3.size.web,
      color: "#666666",
      lineHeight: 20,
    },
  });

  const htmlContent = {
    html: event.description.replace(/\n/g, "<br>"),
  };

  return (
    <View style={styles.container}>
      <SectionTitle title="Overview" />

      {/* Description */}
      <RenderHTML source={htmlContent} baseStyle={styles.description} />

      {/* Highlights Cards TBD*/}
      <View style={styles.highlightsContainer}>
        {event.highlights.map((highlight, index) => (
          <View
            key={index}
            style={[styles.highlightCard, index === 0 && { marginLeft: 0 }]}
          >
            <Text style={styles.highlightTitle}>{highlight.title}</Text>
            <Text style={styles.highlightDescription}>
              {highlight.description}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}

export default EventDescription;
